export const siteConfig = {
  name: "Himanish",
  url: "https://himanishpuri.dev",
  description: "Portfolio of Himanish Puri",
  repo: "https://github.com/himanishpuri/himanish",
  links: {
    githubProfile: "https://github.com/himanishpuri",
    resume:
      "https://drive.google.com/file/d/1tQ0Q1paA7GWiFhyjjnLlSVlxgaXHJzdQ/view?usp=sharing",
    email: "mailto:himanishpuri2235@gmail.com",
    githubUsername: "himanishpuri",
    linkedinProfile: "https://www.linkedin.com/in/himanish-puri-hk108",
    leetcodeUsername: "himanishpuri",
  },
  // Single source of truth for facts shown in multiple places (page copy +
  // the decorative code snippets). Edit once here, never twice.
  profile: {
    fullName: "Himanish Puri",
    email: "himanishpuri2235@gmail.com",
    location: "Patiala, Punjab",
    institute: "Thapar University",
    degree: "B.E. in Computer Science and Business Systems",
    duration: "Aug 2023 - July 2027",
    cgpa: 8.67,
    linkedinHandle: "linkedin.com/in/himanish-puri-hk108/",
    githubHandle: "github.com/himanishpuri",
  },
};

export type SiteConfig = typeof siteConfig;

export const META_THEME_COLORS = {
  light: "#ffffff",
  dark: "#09090b",
};
